const es = {
    FILTERS_BUTTON_DROPDOWN: 'Orden Ascendente',
    DASHBOARD_USERS_FILTER_ALPHABETICAL: 'Alfabético',
    DASHBOARD_USERS_FILTER_NUMERIC: 'Numérico',
    DASHBOARD_USERS_FILTER_DATE: 'Fecha',
    ATTRIBUTES_PLACEHOLDER_SEARCH: 'Buscar atributo de usuario',
    DASHBOARD_USERS_FILTER_ORDER: 'Ordenar por',
    SAVE_FILTERS_BUTTON_CANCEL: 'Cancelar',
    SAVE_FILTERS_BUTTON_SAVE: 'Guardar'
};
const localeEs = es;
export default localeEs;
